import { render, staticRenderFns } from "./SellBusienesAssoclate.vue?vue&type=template&id=2a934d20&scoped=true&"
import script from "./SellBusienesAssoclate.vue?vue&type=script&lang=js&"
export * from "./SellBusienesAssoclate.vue?vue&type=script&lang=js&"
import style0 from "./SellBusienesAssoclate.vue?vue&type=style&index=0&id=2a934d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a934d20",
  null
  
)

export default component.exports